import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getZoneProjectsReports({ uuid }) {
      const state = getState().find(({ zone }) => zone.uuid === uuid);

      return state ? state.reports : [];
    },
    isZoneProjectsReportsRetrievalRequestFailure({ uuid }) {
      const state = getState().find(({ zone }) => zone.uuid === uuid);

      return state ? state.request.isFailure : false;
    },
    isZoneProjectsReportsRetrievalRequestPending({ uuid }) {
      const state = getState().find(({ zone }) => zone.uuid === uuid);

      return state ? state.request.isPending : false;
    },
    isZoneProjectsReportsRetrievalRequestSuccess({ uuid }) {
      const state = getState().find(({ zone }) => zone.uuid === uuid);

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
